<template>
  <a-select class="my-select" 
            :value="props.modelValue" 
            @update:value="emits('update:modelValue', $event)" 
            :options="option?option:props.options" 
            :filter-option="filterOption"
            allowClear>
    <slot></slot>
  </a-select>
</template>

<script setup>
import {ref, defineProps, defineEmits, defineExpose, watchEffect, onMounted, watch, useAttrs} from 'vue';
  const props = defineProps({
    modelValue: {},
    url: {
      type: [Function], 
    },
    params: {
      type: [Object],
      default: () => ({})
    },
    onSetOptions: {
      type: [Function],
    },
    options: {
      type: [Array],
      default: () => []
    },
    show: {
      type: [Boolean],
      default: true,
    },
    onGetFormData: {
      type: [Function],
    },
    //是否允许删除多选数组中不存在数据
    allowDelete: {
      type: [Boolean],
      default: false,
    },
  });
  const emits = defineEmits(['update:modelValue']);
  const option = ref(false);
  const attrs = useAttrs();
  const init = (fun = props.url, params = props.params) => {
    fun(params).then(res => {
      if (props.onSetOptions) {
        option.value = props.onSetOptions(res);
      } else {
        option.value = res.data.records ? res.data.records : res.data;
      }
    })
  };

  const setOption = (options) => {
    option.value = options;
  }

  watch([() => props.url, () => props.params, () => props.show], (v) => {
    props.show && props.url && init(props.url, props.params);
  }, { immediate: true, deep: true });

  watch([() => props.modelValue, () => option], (v) => {
    if (attrs.mode != 'multiple' && (!!props.modelValue || props.modelValue === 0) && !attrs.hasOwnProperty('show-search') && option.value && !option.value.some(res => res[attrs.fieldNames?.value || 'value'] === props.modelValue)) {
      // const formData = props.onGetFormData();
      option.value.unshift({
        [attrs.fieldNames?.value || 'value']: props.modelValue,
        [attrs.fieldNames?.label || 'label']: props.modelValue,
        disabled: true
      })
    }
  }, { immediate: true });

  watch(() => props.options, (val) => { 
    if (props.allowDelete && attrs.mode == 'multiple' && val && val.length>0 && props.modelValue) {
      let list = (props.modelValue || []).filter(ele =>{
        let item = val.find(res => res[attrs.fieldNames?.value || 'value'] === ele);
        return item;
      })
      emits('update:modelValue', list);
    }
  }, { immediate: true });
  const filterOption = (input, option) => {
    //console.log(input, option)
    let removeSpacesStr = String(input || '').trim();
    return option[attrs.fieldNames?.label || 'label'].toLowerCase().indexOf(removeSpacesStr.toLowerCase()) >= 0;
  };

  defineExpose({
    init,
    setOption,
  });
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-select{
    min-width: 200px;
  }
</style>
